<template>
    <div id="autocomplete">
        <v-autocomplete
            v-model="query"
            :items="suggestions"
            item-text="nama"
            return-object
            @change="choose"
            placeholder="Cari berdasarkan bab/subbab"
            outlined
            :rules="rules"
            @click="search"
        ></v-autocomplete>
    </div>
</template>

<script>
export default {
    name: "autocomplete",

    props: [
        "placeholder",
        "data",
        "value",
        "resetable",
        "depth",
        "topic",
        "rules",
    ],

    data: function () {
        return {
            suggestions: [],
            index: [],
            query: "",
            seart: null,
        };
    },
    watch: {
        data: function () {
            this.search();
        },
        // immediate: komponen bisa dibuat saat topic sudah terisi
        // (mis. form edit baru dirender setelah detail selesai dimuat)
        topic: {
            immediate: true,
            handler: function (val) {
                this.query = val
                    ? { id: val, nama: this.value, parents: [] }
                    : "";
                this.search();
            },
        },
    },

    methods: {
        choose: function (selected) {
            this.query = {
                id: selected.id,
                nama: selected.nama,
                parents: selected.parents,
            };

            var result = {
                test: "",
                data: [0, 0, 0],
            };

            var index = 0;
            selected.parents.forEach(function (topic) {
                result.data[index] = topic.id;
                index++;
            });

            result.data[index] = selected.id;
            result.text = selected.nama;
            this.index = result.data;
            this.$emit("selected", result);
        },

        search: function () {
            this.suggestions = [];
            var context = this;
            (this.data || []).forEach(function (node) {
                context.traverse(context.query, node, [], 1);
            });

            // v-autocomplete hanya menampilkan pilihan yang ada di items,
            // jadi samakan query dengan item suggestion yang sesuai
            var current = this.query;
            if (!current || !current.id) return;

            var found =
                this.suggestions.find(function (s) {
                    return s.id == current.id && s.nama === current.nama;
                }) ||
                this.suggestions.find(function (s) {
                    return s.id == current.id;
                });

            if (found) {
                this.query = found;
            } else {
                // Data topik belum dimuat, tampilkan nilai yang tersimpan
                this.suggestions.push(current);
            }
        },

        traverse: function (query, node, parents, level) {
            var nodepath = "";
            parents.forEach(function (parent) {
                nodepath += parent.nama + " >> ";
            });

            this.suggestions.push({
                id: node.id,
                nama: nodepath + node.nama,
                parents: parents,
            });

            if (parseInt(this.depth) && level === parseInt(this.depth)) {
                return;
            }

            if (!node.subs || node.subs.length === 0) {
                return;
            }

            for (var i = 0; i < node.subs.length; i++) {
                this.traverse(
                    query,
                    node.subs[i],
                    parents.concat(node),
                    level + 1,
                );
            }
        },

        refresh: function () {
            this.query = "";
        },
    },
};
</script>



// WEBPACK FOOTER //
// Autocomplete.vue?01233316